import App from '@/App';
import { ekDomain, ROUTES } from '@/configs/constants';
import withAuthentication from '@/hooks/withAuthentication';
import withNonAuthentication from '@/hooks/withNonAuthentication';
import AdminPanelLayout from '@/layouts/AdminPanelLayout';
import BookingLayout from '@/layouts/BookingLayout';
import FormPanelLayout from '@/layouts/FormPanelLayout';
import HomePanelLayout from '@/layouts/HomePanelLayout';
import MyAccountPanelLayout from '@/layouts/MyAccountPanelLayout';
import {
    AccountManagementPage,
    AddAccountEkPage,
    AddAccountGasPage,
    AddNewLocation,
    ApproveBikesPage,
    BikeBookingDetailPage,
    BikeFormPage,
    BikeManagementPage,
    BikeReturnPage,
    ComingSoonPage,
    CouponFormPage,
    CouponManagementPage,
    DashboardPage,
    ForgetPasswordPage,
    HomePage,
    LocationDetailPage,
    AreaLocationPage,
    LocationManagementPage,
    MyAccountPage,
    NotFoundPage,
    OptionManagementPage,
    PriceManagementPage,
    PricePage,
    RegisterStep2EkPage,
    RegisterStep2GasPage,
    RegisterStep3Page,
    ReservationDetailPage,
    ReservationManagementPage,
    ReservationReportBikePage,
    ReservationReturnHistoryPage,
    RevenueManagementPage,
    SetPasswordPage,
    ResetPasswordPage,
    SettingPriceForm,
    SignInPage,
    SignUpPage,
    StatusPaymentPage,
    StepFirstBookingPage,
    StepSecondBookingPage,
    StepThirdBookingPage,
    SystemSettingPage,
    CurrentLocationPage,
    CommissionManagementPage,
    ReservationEditPage,
    CommissionOwnerPage,
    KilometerLimitPgae
} from '@/pages';
import { FORM_TYPE } from '@/types/enums';
import { createBrowserRouter } from 'react-router-dom';

const AdminPanelLayoutWithAuthentication = withAuthentication(AdminPanelLayout);
const MyAccountPanelLayoutWithAuthentication = withAuthentication(MyAccountPanelLayout);
const FormPanelLayoutWithNoneAuthentication = withNonAuthentication(FormPanelLayout);

export const router = createBrowserRouter([
    {
        path: '/',
        element: <App />,
        children: [
            // #region GAS routes
            {
                path: '/',
                children: [
                    {
                        path: '/',
                        element: <HomePanelLayout />,
                        children: [
                            {
                                index: true,
                                element: <HomePage />
                            },
                            {
                                path: `${ROUTES.comingSoon.href}/:id`,
                                element: <ComingSoonPage />
                            },
                            {
                                path: ROUTES.locationList.href,
                                children: [
                                    {
                                        index: true,
                                        element: <AreaLocationPage />
                                    },
                                    {
                                        path: `${ROUTES.locationDetailEnduser.href}/:id`,
                                        children: [
                                            {
                                                index: true,
                                                element: <LocationDetailPage />
                                            },
                                            {
                                                path: `${ROUTES.bikeBookingDetail.href}/:bikeId`,
                                                element: <BikeBookingDetailPage />
                                            },
                                            {
                                                path: '',
                                                element: <BookingLayout />,
                                                children: [
                                                    {
                                                        path: `${ROUTES.bikeBookingFirst.href}/:bikeId`,
                                                        element: <StepFirstBookingPage />
                                                    },
                                                    {
                                                        path: `${ROUTES.bikeBookingSecond.href}/:bikeId`,
                                                        element: <StepSecondBookingPage />
                                                    },
                                                    {
                                                        path: `${ROUTES.bikeBookingThird.href}/:bikeId`,
                                                        element: <StepThirdBookingPage />
                                                    }
                                                ]
                                            }

                                        ]
                                    }
                                ]
                            },
                            {
                                path: ROUTES.locationCurrentList.href,
                                children: [
                                    {
                                        index: true,
                                        element: <CurrentLocationPage />
                                    }
                                ]
                            },
                            {
                                path: ROUTES.priceList.href,
                                element: <PricePage />
                            },
                            {
                                path: `${ROUTES.paymentStatus.href}/:paymentId`,
                                element: <StatusPaymentPage />
                            }
                        ]
                    },
                    {
                        path: '/',
                        element: <MyAccountPanelLayoutWithAuthentication />,
                        children: [
                            {
                                path: ROUTES.myAccount.href,
                                element: <MyAccountPage />,
                                children: [
                                    {
                                        path: ':tabPath',
                                        element: <></>,
                                        children: [
                                            {
                                                path: ':id',
                                                element: <></>
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                path: `${ROUTES.bikeReturn.href}/:orderId`,
                                element: <BikeReturnPage />
                            },
                            {
                                path: `${ROUTES.reservationReportHistoryEnduser.href}/:id`,
                                element: <ReservationReportBikePage formType={FORM_TYPE.View} />
                            },
                            {
                                path: `${ROUTES.reservationReturnHistoryEnduser.href}/:id`,
                                element: <ReservationReturnHistoryPage />
                            }
                        ]
                    },
                    {
                        path: '/',
                        element: <FormPanelLayoutWithNoneAuthentication />,
                        children: [
                            {
                                path: ROUTES.signin.href,
                                element: <SignInPage />
                            },
                            {
                                path: ROUTES.forgetPassword.href,
                                element: <ForgetPasswordPage />
                            },
                            {
                                path: ROUTES.resetPassword.href,
                                element: <ResetPasswordPage />
                            },
                            {
                                path: ROUTES.setPassword.href,
                                element: <SetPasswordPage />
                            },
                            {
                                path: ROUTES.signup.href,
                                element: <SignUpPage />
                            },
                            {
                                path: ROUTES.signup2.href,
                                element: <RegisterStep2GasPage />
                            },
                            {
                                path: ROUTES.signup3.href,
                                element: <RegisterStep3Page />
                            }
                        ]
                    },
                    {
                        path: '/',
                        element: <AdminPanelLayoutWithAuthentication />,
                        children: [
                            {
                                path: ROUTES.dashboard.href,
                                element: <DashboardPage />
                            },
                            {
                                path: ROUTES.userManagement.href,
                                children: [
                                    {
                                        index: true,
                                        element: <AccountManagementPage />
                                    },
                                    {
                                        path: ROUTES.userCreate.href,
                                        element: <AddAccountGasPage formType={FORM_TYPE.Create} />
                                    },
                                    {
                                        path: `${ROUTES.userEdit.href}/:id`,
                                        element: <AddAccountGasPage formType={FORM_TYPE.Edit} />
                                    }
                                ]
                            },
                            {
                                path: ROUTES.locationManagement.href,
                                children: [
                                    {
                                        index: true,
                                        element: <LocationManagementPage />
                                    },
                                    {
                                        path: ROUTES.locationCreate.href,
                                        element: <AddNewLocation formType={FORM_TYPE.Create} />
                                    },
                                    {
                                        path: `${ROUTES.locationEdit.href}/:id`,
                                        element: <AddNewLocation formType={FORM_TYPE.Edit} />
                                    }
                                ]
                            },
                            {
                                path: ROUTES.priceManagement.href,
                                children: [
                                    {
                                        index: true,
                                        element: <PriceManagementPage />
                                    },
                                    {
                                        path: ROUTES.priceCreate.href,
                                        element: <SettingPriceForm formType={FORM_TYPE.Create} />
                                    },
                                    {
                                        path: `${ROUTES.priceEdit.href}/:id`,
                                        element: <SettingPriceForm formType={FORM_TYPE.Edit} />
                                    }
                                ]
                            },
                            {
                                path: ROUTES.revenueManagement.href,
                                children: [
                                    {
                                        index: true,
                                        element: <RevenueManagementPage />
                                    }
                                ]
                            },
                            {
                                path: ROUTES.commissionManagement.href,
                                children: [
                                    {
                                        index: true,
                                        element: <CommissionManagementPage />
                                    },
                                    {
                                        path: ROUTES.commissionOwnerMontly.href,
                                        element: <CommissionOwnerPage />
                                    }
                                ]
                            },
                            {
                                path: ROUTES.optionManagement.href,
                                element: <OptionManagementPage />
                            },
                            {
                                path: ROUTES.reservationManagement.href,
                                children: [
                                    {
                                        index: true,
                                        element: <ReservationManagementPage />
                                    },
                                    {
                                        path: `${ROUTES.reservationDetail.href}/:id`,
                                        element: <ReservationDetailPage />
                                    },
                                    {
                                        path: `${ROUTES.reservationEdit.href}/:id`,
                                        element: <ReservationEditPage />
                                    },
                                    {
                                        path: `${ROUTES.reservationReturnHistory.href}/:id`,
                                        element: <ReservationReturnHistoryPage />
                                    }
                                ]
                            },
                            {
                                // path: ROUTES.systemSetting.href,
                                path: '/setting/system',
                                element: <SystemSettingPage />
                            },
                            {
                                path: ROUTES.kilometerLimitManagement.href,
                                element: <KilometerLimitPgae />
                            },
                            {
                                path: ROUTES.couponSetting.href,
                                children: [
                                    {
                                        index: true,
                                        element: <CouponManagementPage />
                                    },
                                    {
                                        path: `${ROUTES.couponCreate.href}/:couponPathType`,
                                        element: <CouponFormPage type={FORM_TYPE.Create} />
                                    },
                                    {
                                        path: `${ROUTES.couponEdit.href}/:couponPathType/:id`,
                                        element: <CouponFormPage type={FORM_TYPE.Edit} />
                                    }
                                ]
                            },
                            {
                                path: ROUTES.bikeManagement.href,
                                children: [
                                    {
                                        index: true,
                                        element: <BikeManagementPage />
                                    },
                                    {
                                        path: `${ROUTES.bikeCreate.href}`,
                                        element: <BikeFormPage type={FORM_TYPE.Create} />
                                    },
                                    {
                                        path: `${ROUTES.bikeEdit.href}/:id`,
                                        element: <BikeFormPage type={FORM_TYPE.Edit} />
                                    },
                                    {
                                        path: `${ROUTES.bikeDetail.href}/:id`,
                                        element: <BikeFormPage type={FORM_TYPE.View} />
                                    }
                                ]
                            },
                            {
                                path: ROUTES.approveBikes.href,
                                element: <ApproveBikesPage />
                            }
                        ]
                    },
                    {
                        path: '/',
                        element: <AdminPanelLayoutWithAuthentication isTakeAllSpace />,
                        children: [
                            {
                                path: ROUTES.reservationManagement.href,
                                children: [
                                    {
                                        path: `${ROUTES.reservationReportBike.href}/:id`,
                                        element: <ReservationReportBikePage />
                                    },
                                    {
                                        path: `${ROUTES.reservationReportHistory.href}/:id`,
                                        element: <ReservationReportBikePage formType={FORM_TYPE.View} />
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            // #endregion GAS routes

            // #region EK routes
            {
                path: `/${ekDomain}`,
                children: [
                    {
                        path: `/${ekDomain}`,
                        element: <HomePanelLayout />,
                        children: [
                            {
                                index: true,
                                element: <HomePage />
                            },
                            {
                                path: ROUTES.comingSoon.hrefEK,
                                element: <ComingSoonPage />
                            },
                            {
                                path: ROUTES.locationList.hrefEK,
                                children: [
                                    {
                                        index: true,
                                        element: <AreaLocationPage />
                                    },
                                    {
                                        path: `${ROUTES.locationDetailEnduser.hrefEK}/:id`,
                                        children: [
                                            {
                                                index: true,
                                                element: <LocationDetailPage />
                                            },
                                            {
                                                path: `${ROUTES.bikeBookingDetail.href}/:bikeId`,
                                                element: <BikeBookingDetailPage />
                                            },
                                            {
                                                path: '',
                                                element: <BookingLayout />,
                                                children: [
                                                    {
                                                        path: `${ROUTES.bikeBookingFirst.href}/:bikeId`,
                                                        element: <StepFirstBookingPage />
                                                    },
                                                    {
                                                        path: `${ROUTES.bikeBookingSecond.href}/:bikeId`,
                                                        element: <StepSecondBookingPage />
                                                    },
                                                    {
                                                        path: `${ROUTES.bikeBookingThird.href}/:bikeId`,
                                                        element: <StepThirdBookingPage />
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                path: ROUTES.locationCurrentList.hrefEK,
                                children: [
                                    {
                                        index: true,
                                        element: <CurrentLocationPage />
                                    }
                                ]
                            },
                            {
                                path: ROUTES.priceList.hrefEK,
                                element: <PricePage />
                            },
                            {
                                path: `${ROUTES.paymentStatus.href}/:paymentId`,
                                element: <StatusPaymentPage />
                            }
                        ]
                    },
                    {
                        path: `/${ekDomain}`,
                        element: <MyAccountPanelLayoutWithAuthentication />,
                        children: [
                            {
                                path: ROUTES.myAccount.hrefEK,
                                element: <MyAccountPage />,
                                children: [
                                    {
                                        path: ':tabPath',
                                        element: <></>,
                                        children: [
                                            {
                                                path: ':id',
                                                element: <></>
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                path: `${ROUTES.bikeReturn.hrefEK}/:orderId`,
                                element: <BikeReturnPage />
                            },
                            {
                                path: `${ROUTES.reservationReportHistoryEnduser.hrefEK}/:id`,
                                element: <ReservationReportBikePage formType={FORM_TYPE.View} />
                            },
                            {
                                path: `${ROUTES.reservationReturnHistoryEnduser.hrefEK}/:id`,
                                element: <ReservationReturnHistoryPage />
                            }
                        ]
                    },
                    {
                        path: '',
                        element: <FormPanelLayoutWithNoneAuthentication />,
                        children: [
                            {
                                // path: ROUTES.signin.href,
                                path: 'sign-in',
                                element: <SignInPage />
                            },
                            {
                                // path: ROUTES.forgotPassword.href,
                                path: ROUTES.forgetPassword.hrefEK,
                                element: <ForgetPasswordPage />
                            },
                            {
                                path: ROUTES.resetPassword.hrefEK,
                                element: <ResetPasswordPage />
                            },
                            {
                                // path: ROUTES.setPassword.href,
                                path: 'users/set-password',
                                element: <SetPasswordPage />
                            },
                            {
                                path: ROUTES.signup.hrefEK,
                                // path: 'sign-up',
                                element: <SignUpPage />
                            },
                            {
                                path: ROUTES.signup2.hrefEK,
                                element: <RegisterStep2EkPage />
                            },
                            {
                                path: ROUTES.signup3.hrefEK,
                                element: <RegisterStep3Page />
                            }
                        ]
                    },
                    {
                        path: '',
                        element: <AdminPanelLayoutWithAuthentication />,
                        children: [
                            {
                                // path: ROUTES.dashboard.href,
                                path: 'dashboard',
                                element: <DashboardPage />
                            },
                            {
                                // path: ROUTES.userManagement.href,
                                path: 'accounts-management',
                                children: [
                                    {
                                        index: true,
                                        element: <AccountManagementPage />
                                    },
                                    {
                                        path: ROUTES.userCreate.href,
                                        element: <AddAccountEkPage formType={FORM_TYPE.Create} />
                                    },
                                    {
                                        path: `${ROUTES.userEdit.href}/:id`,
                                        element: <AddAccountEkPage formType={FORM_TYPE.Edit} />
                                    }
                                ]
                            },
                            {
                                // path: ROUTES.locationManagement.href,
                                path: 'locations-management',
                                children: [
                                    {
                                        index: true,
                                        element: <LocationManagementPage />
                                    },
                                    {
                                        path: ROUTES.locationCreate.href,
                                        element: <AddNewLocation formType={FORM_TYPE.Create} />
                                    },
                                    {
                                        path: `${ROUTES.locationEdit.href}/:id`,
                                        // element: <EditLocation />
                                        element: <AddNewLocation formType={FORM_TYPE.Edit} />
                                    }
                                ]
                            },
                            {
                                // path: ROUTES.optionManagement.href,
                                path: 'option',
                                element: <OptionManagementPage />
                            },
                            {
                                path: ROUTES.reservationManagement.hrefEK,
                                children: [
                                    {
                                        index: true,
                                        element: <ReservationManagementPage />
                                    },
                                    {
                                        path: `${ROUTES.reservationDetail.hrefEK}/:id`,
                                        element: <ReservationDetailPage />
                                    },
                                    {
                                        path: `${ROUTES.reservationEdit.hrefEK}/:id`,
                                        element: <ReservationEditPage />
                                    },
                                    {
                                        path: `${ROUTES.reservationReturnHistory.href}/:id`,
                                        element: <ReservationReturnHistoryPage />
                                    }
                                ]
                            },
                            {
                                // path: ROUTES.systemSetting.href,
                                path: 'setting/system',
                                element: <SystemSettingPage />
                            },
                            {
                                path: ROUTES.couponSetting.hrefEK,
                                children: [
                                    {
                                        index: true,
                                        element: <CouponManagementPage />
                                    },
                                    {
                                        path: `${ROUTES.couponCreate.href}/:couponPathType`,
                                        element: <CouponFormPage type={FORM_TYPE.Create} />
                                    },
                                    {
                                        path: `${ROUTES.couponEdit.href}/:couponPathType/:id`,
                                        element: <CouponFormPage type={FORM_TYPE.Edit} />
                                    }
                                ]
                            },
                            {
                                path: ROUTES.bikeManagement.hrefEK,
                                children: [
                                    {
                                        index: true,
                                        element: <BikeManagementPage />
                                    },
                                    {
                                        path: `${ROUTES.bikeCreate.hrefEK}`,
                                        element: <BikeFormPage type={FORM_TYPE.Create} />
                                    },
                                    {
                                        path: `${ROUTES.bikeEdit.hrefEK}/:id`,
                                        element: <BikeFormPage type={FORM_TYPE.Edit} />
                                    },
                                    {
                                        path: `${ROUTES.bikeDetail.hrefEK}/:id`,
                                        element: <BikeFormPage type={FORM_TYPE.View} />
                                    }
                                ]
                            },
                            {
                                path: ROUTES.priceManagement.hrefEK,
                                children: [
                                    {
                                        index: true,
                                        element: <PriceManagementPage />
                                    },
                                    {
                                        path: ROUTES.priceCreate.hrefEK,
                                        element: <SettingPriceForm formType={FORM_TYPE.Create} />
                                    },
                                    {
                                        path: `${ROUTES.priceEdit.hrefEK}/:id`,
                                        element: <SettingPriceForm formType={FORM_TYPE.Edit} />
                                    }
                                ]
                            },
                            {
                                path: ROUTES.revenueManagement.hrefEK,
                                children: [
                                    {
                                        index: true,
                                        element: <RevenueManagementPage />
                                    }
                                ]
                            },
                            {
                                path: ROUTES.commissionManagement.hrefEK,
                                children: [
                                    {
                                        index: true,
                                        element: <CommissionManagementPage />
                                    },
                                    {
                                        path: ROUTES.commissionOwnerMontly.hrefEK,
                                        element: <CommissionOwnerPage />
                                    }
                                ]
                            },
                            {
                                path: ROUTES.approveBikes.hrefEK,
                                element: <ApproveBikesPage />
                            }
                        ]
                    },
                    {
                        path: `/${ekDomain}`,
                        element: <AdminPanelLayoutWithAuthentication isTakeAllSpace />,
                        children: [
                            {
                                path: ROUTES.reservationManagement.hrefEK,
                                children: [
                                    {
                                        path: `${ROUTES.reservationReportBike.href}/:id`,
                                        element: <ReservationReportBikePage />
                                    },
                                    {
                                        path: `${ROUTES.reservationReportHistory.href}/:id`,
                                        element: <ReservationReportBikePage formType={FORM_TYPE.View} />
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                path: '*',
                element: (
                    <HomePanelLayout isErrorPage={true}>
                        <NotFoundPage />
                    </HomePanelLayout>
                )
            }
        ]
    }
], {
    basename: process.env.PUBLIC_URL || '/'
});
